<template>
  <div class="member-list" :class="parentClass">
    <div v-for="member in hgMembers" :key="member.id" class="member">
      <div class="details">
        <h4>{{member.givenName}} {{member.familyName}}</h4>
        <h5>{{member.company}}</h5>
        <div class="contact">
          <span v-if="member.primaryPhone">{{member.primaryPhone}}</span>
          <a :href="'mailto:'+ member.primaryEmail" class="link email" >{{member.primaryEmail}}</a>
        </div>
      </div>
      <router-link
        class="link test-review-inspector"
        v-if="hgLink && member.canReview"
        :to="`/inspector/${member.id}/rate`">
        Review Your Inspector
      </router-link>
      <v-img
        v-if="hgShowInspectorAgentPhotos && member.profileUrl"
        class="profile__icon"
        alt="Profile icon"
        min-width="80px"
        max-width="80px"
        max-height="75px"
        :src='member.profileUrl'/>
    </div>
  </div>
</template>

<script>

const parentComponentSelector = parent => ({
  INSPECTION: 'inspection',
  INSPECTORS: 'inspectors',
})[parent];

export default {
  props: {
    hgMembers: {
      type: Array,
      required: true,
    },
    hgLink: {
      type: String,
      required: false,
    },
    hgParentComponent: {
      type: String,
      required: false,
    },
    hgShowInspectorAgentPhotos: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    /* parent class is used to control display based on where this component is displayed. */
    parentClass() {
      return parentComponentSelector(this.hgParentComponent);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.details {
  flex: 1 1 auto;
}

.member-list {
  color: $theme-color-gray;
}

h4 {
  font-size: 1.214rem;
  display: inline-block;
}

h5 {
  font-size: 1rem;
}

.link {
  color: $typography-color-link;
  text-decoration: underline;
}

.email {
  text-transform: lowercase;
}

.member {
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
}

.logo-image {
  background-position:center;
  background-repeat:no-repeat;
  background-size: cover;
  height: 80px;
  width: 138px;
}

.inspectors {
  .member {
    align-items: center;
    border-bottom: solid 1px rgba($theme-color-black, 0.15);
    padding-bottom: 50px;
    padding-top: 50px;
    text-align: center;

    &:last-child {
      border-bottom: none;
    }
  }

  h4 {
    font-size: 1.714rem;
  }

  .logo {
    padding-bottom: 30px;
  }
}

.contact {
  padding-bottom: 20px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  word-break: break-all;
}

@media all and (min-width: 955px) {
  .member {
    flex-direction: row;
  }

  .inspectors {
    .h4 {
      margin-bottom: 10px
    }

    .contact {
      padding: 20px 0 0 0;
    }

    .link {
      flex: 0 0 150px;
    }

    .logo {
      flex: 0 0 138px;
      padding-bottom: 0;
      padding-right: 50px;
    }

    .member {
      align-items: flex-start;
      padding: 70px;
      text-align: left;
    }
  }

  .inspection  {
    .contact {
      margin-bottom: 0;
      margin-top: 0;
    }
  }
}

</style>
